import { __assign, __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { logDebugCacheEvent } from '@office-start/instrumentation-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { logDiagnostic, logError, logFeature, } from '@office-start/telemetry-service';
import { launchNativeFile } from './launchNativeFile';
import { launchUrl } from './launchUrl';
import { launchWebApp } from './launchWebApp';
import { logClick } from './logClick';
import { shouldOpenInOfficeApp } from './shouldOpenInOfficeApp';
export var launchApp = function (launchAppParams, launchInstrumentationParams) { return __awaiter(void 0, void 0, void 0, function () {
    var result, eventName, officeComponentContext, appName, url, shouldOpenHwaInNativeFile, _a, disableDefaultLinkBehavior, event_1, prelaunchCallback, nativeLaunchResult, _b, action, targetTab, error_1, debugInfo, message, params, params;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                result = { success: false };
                eventName = 'launchApp';
                _e.label = 1;
            case 1:
                _e.trys.push([1, 14, 15, 16]);
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 2:
                officeComponentContext = _e.sent();
                appName = launchAppParams.appName;
                url = launchAppParams.url;
                _a = officeComponentContext.workload == OfficeWorkload.Hwa &&
                    appName;
                if (!_a) return [3 /*break*/, 4];
                return [4 /*yield*/, shouldOpenInOfficeApp(appName)];
            case 3:
                _a = (_e.sent());
                _e.label = 4;
            case 4:
                shouldOpenHwaInNativeFile = _a;
                if (!shouldOpenHwaInNativeFile) return [3 /*break*/, 11];
                disableDefaultLinkBehavior = launchAppParams.disableDefaultLinkBehavior, event_1 = launchAppParams.event;
                prelaunchCallback = event_1 && !event_1.defaultPrevented && !disableDefaultLinkBehavior
                    ? function () { return event_1 === null || event_1 === void 0 ? void 0 : event_1.preventDefault(); }
                    : undefined;
                nativeLaunchResult = undefined;
                _e.label = 5;
            case 5:
                _e.trys.push([5, 7, , 8]);
                return [4 /*yield*/, launchNativeFile({
                        appName: appName,
                        filePath: launchAppParams.useUrl ? url : '',
                        prelaunchCallback: prelaunchCallback,
                    })];
            case 6:
                nativeLaunchResult = _e.sent();
                logClick({
                    launchInstrumentationParams: launchInstrumentationParams,
                    success: nativeLaunchResult.success,
                });
                if (nativeLaunchResult.success) {
                    result = __assign(__assign({}, nativeLaunchResult), { result: 'Native' });
                }
                return [3 /*break*/, 8];
            case 7:
                _b = _e.sent();
                return [3 /*break*/, 8];
            case 8:
                if (!!(nativeLaunchResult === null || nativeLaunchResult === void 0 ? void 0 : nativeLaunchResult.success)) return [3 /*break*/, 10];
                return [4 /*yield*/, launchWebApp(url, launchAppParams, launchInstrumentationParams)];
            case 9:
                result = _e.sent();
                _e.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                action = 'OpenInApp';
                targetTab = launchAppParams.targetTab;
                return [4 /*yield*/, launchUrl(url, { action: action, targetTab: targetTab }, launchInstrumentationParams)];
            case 12:
                result = _e.sent();
                _e.label = 13;
            case 13: return [3 /*break*/, 16];
            case 14:
                error_1 = _e.sent();
                debugInfo = void 0;
                message = void 0;
                if (error_1 instanceof Error) {
                    debugInfo = error_1.stack;
                    message = error_1.message;
                }
                else if (typeof error_1 === 'string') {
                    message = error_1;
                }
                else if (typeof error_1 === 'object') {
                    message = error_1 === null || error_1 === void 0 ? void 0 : error_1.toString();
                }
                logError({
                    debugInfo: debugInfo,
                    errorType: 'LaunchApp_Error',
                    eventName: eventName,
                    message: message,
                });
                // While debugInfo is passed to logError it does not yet
                // automatically get logged to diagnostics table
                // $TODO: Remove this once debugInfo is hooked up in logError
                if (debugInfo) {
                    params = {
                        DebugInfo: debugInfo,
                        Message: message !== null && message !== void 0 ? message : '',
                    };
                    logDiagnostic({
                        eventName: eventName,
                        params: params,
                    });
                    // TODO: Remove when Otel is enabled
                    logDebugCacheEvent(eventName, params, []);
                }
                return [3 /*break*/, 16];
            case 15:
                params = {
                    Success: result.success,
                    Message: (_c = result.message) !== null && _c !== void 0 ? _c : '',
                    AppLaunchResult: (_d = result.result) !== null && _d !== void 0 ? _d : '',
                };
                logFeature({
                    eventName: eventName,
                    featureName: "LauncherService" /* KnownFeatureNames.LauncherService */,
                    params: params,
                });
                return [7 /*endfinally*/];
            case 16: return [2 /*return*/, result];
        }
    });
}); };
//# sourceMappingURL=launchApp.js.map